import React from 'react';
import * as R from 'ramda';
import { useWindowSize } from 'react-use';
// helpers/constants
import * as GC from '../../../constants';
// feature payroll
import TripTab from './trip-tab';
import PaymentInfo from './payment-info';
import ExpensesTab from './expenses-tab';
import FuelCardsTab from './fuel-cards-tab';
import DailyHoursTab from './daily-hours-tab';
import TollChargesTab from './toll-charges-tab';
import PayrollChargesTab from './payroll-charges-tab';
import AdvancePaymentTab from './advance-payment-tab';
//////////////////////////////////////////////////

const ActiveTab = (props: Object) => {
  const { activeTab, collapsedView, vendorFuelCards, vendorTollCharges } = props;

  const { height } = useWindowSize();

  const maxHeight = collapsedView ? R.subtract(height, 550) : R.subtract(height, 220);

  if (R.equals(activeTab, 0)) {
    return <PayrollChargesTab {...props} withoutTotals={true} />;
  } else if (R.equals(activeTab, 1)) {
    return (
      <FuelCardsTab
        {...props}
        key='driverFuelCards'
        maxHeight={maxHeight}
        omitReportFields={[GC.FIELD_DRIVER]}
      />
    );
  } else if (R.equals(activeTab, 2)) {
    return (
      <FuelCardsTab
        {...props}
        noActions={true}
        key='vendorFuelCards'
        maxHeight={maxHeight}
        fuelCards={vendorFuelCards}
        omitReportFields={[GC.FIELD_DRIVER]}
      />
    );
  } else if (R.equals(activeTab, 3)) {
    return (
      <TollChargesTab
        {...props}
        maxHeight={maxHeight}
        key='driverTollCharges'
        omitReportFields={[GC.FIELD_DRIVER]}
      />
    );
  } else if (R.equals(activeTab, 4)) {
    return (
      <TollChargesTab
        {...props}
        noActions={true}
        maxHeight={maxHeight}
        key='vendorTollCharges'
        tollCharges={vendorTollCharges}
        omitReportFields={[GC.FIELD_DRIVER]}
      />
    );
  } else if (R.equals(activeTab, 5)) {
    return <AdvancePaymentTab {...props} maxHeight={maxHeight} />;
  } else if (R.equals(activeTab, 6)) {
    return <ExpensesTab {...props} maxHeight={maxHeight} />;
  } else if (R.equals(activeTab, 7)) {
    return <DailyHoursTab {...props} maxHeight={maxHeight} />;
  } else if (R.equals(activeTab, 8)) {
    return <TripTab {...props} maxHeight={maxHeight} />;
  }

  return <PaymentInfo {...props} />;
};

export default ActiveTab;
